// import ServerConnection from "../ServerConnection/ServerConnection";

class UserPermissionsService {

    userHasRole(role, entityType, entityId){
         var user = JSON.parse(localStorage.getItem("user"));
         if(!user || !user.permissions){
            return false;
         }
         var permissions = user.permissions.filter(p => p.role == role);
         if(!permissions || permissions.length <= 0){
            return false;
         }
         if(entityType && entityId){
            if(permissions.find(p => p.entityType == entityType && p.entityIds.find(id => id == entityId))){
                return true;
            }
         }else{
            return true;
         }
         return false;
     }
}
export default new UserPermissionsService();